import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-cmd-fourniss',
  templateUrl: './document-cmd-fourniss.component.html',
  styleUrls: ['./document-cmd-fourniss.component.scss']
})
export class DocumentCmdFournissComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
